
import { toast } from "sonner";

interface UppdragUtilsProps {
  handleSelectProject: (projectId: string) => Promise<string>;
  refreshFolderTree: () => void;
  fetchDefaultProject: () => void;
}

export const createUppdragUtils = ({
  handleSelectProject,
  refreshFolderTree,
  fetchDefaultProject
}: UppdragUtilsProps) => {
  const handleProjectChange = async (newProjectId: string) => {
    try {
      await handleSelectProject(newProjectId);
      refreshFolderTree();
    } catch (error) {
      console.error("Error changing project:", error);
      toast.error("Kunde inte byta projekt");
    }
  };

  const handleRetry = () => {
    toast.info("Försöker ladda om data...");
    console.log("Manual retry triggered");
    fetchDefaultProject();
  };

  return {
    handleProjectChange,
    handleRetry
  };
};
